import React, { useState, useEffect } from "react";
import {
  Table,
  TableHeader,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  TableCellLayout,
} from "@fluentui/react-components";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import "../CSS/LicencesComponent.css";
import { getAccessToken } from "../../Services/GraphServices";
import { getAllLicences } from "../../Services/HeedifyServices";
import InfoButton from "../GenericComponent/InfoButton";

import { useAbility } from "../../Contexts/AbilityContext";
const LicencesComponent = (props) => {
  const authContext = useMsal();
  let accounts = authContext.accounts;
  let instance = authContext.instance;
  const activeAccount = accounts[0];
  const { t } = useTranslation();

  const ability = useAbility();
  const [licencesRows, setLicencesRows] = useState([]);
  const getAllLicence = () => {
    getAccessToken(instance, activeAccount)
      .then((token) => {
        if (props.SCOPES_NAMES && props.SCOPES_NAMES.length > 0) {
          const licencesPromises = props.SCOPES_NAMES.map((scopeName) =>
            getAllLicences(props.ACTIVE_TENANT, token, scopeName)
              .then((licences) => licences)
              .catch((err) => {
                console.error(
                  `Erreur lors du getAllLicences pour ${scopeName}:`,
                  err
                );
              })
          );

          Promise.all(licencesPromises)
            .then((results) => {
              props.setLicences(results);
            })
            .catch((err) => {
              console.error("Erreur lors du traitement des licences:", err);
            });
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération du token:", error);
      });
  };

  const formatLicencesData = (licences, scopes) => {
    const rows = [];
    scopes.forEach((scope, i) => {
      const scopeData = licences.find((licence) => licence.RowKey === scope);
      
      // Check if scopeData exists before processing
      if (!scopeData) {
        console.warn(`No licence data found for scope: ${scope}`);
        return;
      }
      
      // 🔐 Calculer permissions pour ce scope
      const permissions = {
        main: {
          canCreate: ability?.can("create", `Licences.main@${scope}`) ,
          canRead: ability?.can("read", `Licences.main@${scope}`) ,
          canUpdate: ability?.can("update", `Licences.main@${scope}`) ,
          canDelete: ability?.can("delete", `Licences.main@${scope}`) ,
        },
      };
      
      const licencesNames = Object.keys(scopeData).filter(
        (key) =>
          !key.includes("PartitionKey") &&
          !key.includes("RowKey") &&
          !key.includes("AVAILABLE_") &&
          !key.includes("USED_")
      );

      licencesNames.forEach((licenceName) => {
        rows.push({
          licence: licenceName,
          scope,
          total: scopeData[licenceName],
          used: scopeData[`USED_${licenceName}`] ?? 0,
          available: scopeData[`AVAILABLE_${licenceName}`] ?? 0,
          permissions, // ✅ Ajouter permissions
        });
      });
    });

    return rows;
  };
  useEffect(() => {
    if (props.SCOPES_NAMES && props.SCOPES_NAMES.length > 0) {
      getAllLicence();
    }
  }, [props.SCOPES_NAMES]);
  useEffect(() => {
    if (
      props.LICENCES &&
      props.LICENCES.length > 0 &&
      props.SCOPES_NAMES &&
      props.SCOPES_NAMES.length > 0
    ) {
      const formattedRows = formatLicencesData(
        props.LICENCES,
        props.SCOPES_NAMES
      );
      setLicencesRows(formattedRows);
    }
  }, [props.LICENCES, props.SCOPES_NAMES]);

  // 🔐 Filtrer les lignes selon permissions.main.canRead
  const filteredRows = licencesRows.filter(row => row.permissions?.main?.canRead);

  const columns = [
    { columnKey: "LICENCE", label: t("LICENCE") },
    { columnKey: "SCOPE", label: t("SCOPE") },
    { 
      columnKey: "TOTAL", 
      label: (
        <>
          {t("TOTAL")}
          <InfoButton infoKey="TOTAL" category="LICENCES" />
        </>
      )
    },
    { 
      columnKey: "USED", 
      label: (
        <>
          {t("USED")}
          <InfoButton infoKey="USED" category="LICENCES" />
        </>
      )
    },
    { 
      columnKey: "AVAILABLE", 
      label: (
        <>
          {t("AVAILABLE")}
          <InfoButton infoKey="AVAILABLE" category="LICENCES" />
        </>
      )
    },
  ];

 

  if (filteredRows.length === 0 && licencesRows.length > 0) {
    return (
      <div className="access-denied-message">
        <h2>{t("LICENCES_ACCESS_DENIED")}</h2>
        <p>{t("LICENCES_NO_PERMISSION_TO_VIEW")}</p>
      </div>
    );
  }

  return (
    <>
      <div >
      <h2>{t("LICENCES")}</h2>
      <div className="table-container">
        <Table role="grid" aria-label="Licences table" className="table-style">
          <TableHeader>
            <TableRow className="header-style">
              {columns.map((column) => (
                <TableHeaderCell
                className="cell-bold"
                  key={column.columnKey}
                >
                  {column.label}
                </TableHeaderCell>
              ))}
            </TableRow>
          </TableHeader>

          <TableBody>
            {filteredRows.map((row ,index) => (
              <TableRow key={index}>
                <TableCell role="gridcell">
                  <TableCellLayout>{t(row.licence)}</TableCellLayout>
                </TableCell>

                <TableCell role="gridcell">{row.scope}</TableCell>

                <TableCell role="gridcell">{row.total}</TableCell>

                <TableCell role="gridcell">{row.used}</TableCell>

                <TableCell role="gridcell">{row.available}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      </div>
    </>
  );
};

export default LicencesComponent;
